import { render } from "./BackgrounderCase.vue?vue&type=template&id=3fc03eb3&scoped=true"
import script from "./BackgrounderCase.vue?vue&type=script&lang=js"
export * from "./BackgrounderCase.vue?vue&type=script&lang=js"

import "./BackgrounderCase.vue?vue&type=style&index=0&id=3fc03eb3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc03eb3"]])

export default __exports__